import { WizardTranslations } from "./wizard-pt-br";

export const WIZARD_FR_FR: WizardTranslations = {
	common: {
		pointsOfSale: "Points de vente",
	},
	welcome: {
		title: "Bienvenue, <placeName>{{placeName}}</placeName> !",
		subtitle: "Choisissez comment vous voulez configurer votre opération.",
		skipButton: "Je ne veux pas configurer maintenant",
		placeIdNotFound: "ID de lieu non trouvé",
		features: {
			preConfiguredSteps: "Étapes avec suggestions préconfigurées",
			guidedStepsWithAI: "Étape par étape guidé avec l'aide de l'IA",
			advancedConfigurations: "Configurations avancées et personnalisations",
			complexFeatures: "Fonctionnalités plus complexes",
		},
		guidedMode: {
			title: "Création guidée (mode simplifié)",
			subtitle: "Nous vous guidons étape par étape",
			buttonText: "Accéder au mode simplifié",
			features: {
				basicConfigurations: "Configurations plus basiques",
				idealForSimpleOperations:
					"Idéal pour les opérations plus simples et plus petites",
			},
		},
		advancedMode: {
			title: "Création avancée",
			subtitle: "Plus d'options et détails de configuration",
			buttonText: "Accéder au mode avancé",
			features: {
				directConfiguration: "Configuration directe dans les modules du Dashboard",
				idealForComplexOperations: "Idéal pour les opérations grandes et complexes",
			},
		},
	},
	container: {
		stepIndexTitle: "Configurez votre lieu",
		buttons: {
			back: "Retour",
			close: "Fermer",
			next: "Suivant",
			configureLater: "Configurer plus tard",
			finishConfiguration: "Terminer la configuration",
		},
		finishConfirmation: {
			title: "Terminer la configuration de l'opération",
			descriptionPart1:
				"Vous êtes sur le point de terminer la configuration de cette opération.",
			descriptionPart2:
				"Un résumé final sera généré et sera disponible pour consultation à tout moment. Ensuite, vous pourrez réviser et modifier si nécessaire.",
			cancelButton: "Annuler",
			confirmButton: "Terminer la configuration",
			successMessage: "Configuration enregistrée avec succès !",
		},
		closeModalConfirmation: {
			title: "Quitter la configuration sans enregistrer ?",
			description:
				"En fermant maintenant, les informations configurées jusqu'à présent ne seront pas enregistrées et vous perdrez la progression. Souhaitez-vous continuer ?",
			cancelButton: "Continuer la configuration",
			confirmButton: "Quitter sans enregistrer",
		},
		steps: {
			basicInformation: {
				title: "Informations de base",
				subtitle: "Configurez le type d'opération",
				operationType: {
					title: "Comment les clients <highlight>achèteront</highlight>-ils ?",
					subtitle:
						"Choisissez un ou plusieurs formats qui s'appliqueront à cette opération.",
					alert: {
						message: "Ces options sont déjà marquées dans le contrat de votre opération.",
						description:
							"Vous pouvez les garder telles quelles ou les ajuster si vous le souhaitez.",
					},
					subStepTitle: "Type d'opération",
				},
				funcionalities: {
					title:
						"Quelles seront les <highlight>fonctionnalités</highlight> de cette opération ?",
					subtitle:
						"Les fonctionnalités sont des options avec des ressources qui permettent de configurer l'opération de manière personnalisée.",
					subStepTitle: "Fonctionnalités",
					searchFunctionalities: "Rechercher par fonctionnalité",
					placeholderSearchFunctionalities: "Entrez ici la fonctionnalité",
					activeLabel: "actives",
					loadingText: "Chargement des fonctionnalités...",
					emptySearchResults: "Aucune fonctionnalité trouvée",
				},
				review: {
					title:
						"Nous avons déjà compris les <highlight>configurations initiales</highlight> de l'opération !",
					subtitle: "Selon vos réponses, le système configurera :",
					subStepTitle: "Révision",
					reviewTitle: "Réviser les réponses",
					reviewSubtitle:
						"Vous pourrez les modifier maintenant ou quand vous en aurez besoin.",
					editStep: "Modifier l'étape",
					operationTypeLabel: "Type d'opération",
					functionalitiesLabel: "Fonctionnalités",
					notInformed: "Non renseigné",
					viewFunctionalities: "Voir les fonctionnalités",
				},
			},
			pointsOfSale: {
				title: "Points de vente",
				subtitle: "Configurez les emplacements de vente",
			},
			menu: {
				title: "Menu",
				subtitle: "Configurez les produits",
			},
			employees: {
				title: "Employés",
				subtitle: "Configurez l'équipe de l'opération",
			},
		},
		operationTypes: {
			token: {
				label: "Jeton",
				description: "Le client échange un jeton contre un produit",
			},
			cashlessPrepaid: {
				label: "Cashless (prépaié)",
				description: "Le client charge du crédit sur une carte",
			},
			cashlessPostpaid: {
				label: "Cashless (postpayé)",
				description: "Le client paie sur une carte après consommation",
			},
			directSale: {
				label: "Vente directe au bar",
				description: "Le client paie le produit directement",
			},
			tables: {
				label: "Tables",
				description: "Le client passe commande auprès des serveurs",
			},
		},
		summary: {
			title: "Résumé de la configuration de <placeName>{{placeName}}</placeName> !",
			subtitle:
				"Modifiez les réponses, revenez aux étapes ou accédez aux paramètres avancés à tout moment.",
			editStep: "Modifier l'étape",
			operationType: "Type d'opération",
			functionalities: "Fonctionnalités",
			viewFunctionalities: "Voir les fonctionnalités",
			advancedConfigurations: "Paramètres avancés des fonctionnalités",
			notInformed: "Non renseigné",
			pendingAction: "Action en attente",
			loading: "Chargement des paramètres...",
			placeIdNotFound: "ID de lieu non trouvé",
			errorLoading: "Erreur lors du chargement des données",
		},
	},
	components: {
		pdvCard: {
			menu: {
				edit: "Modifier",
				remove: "Supprimer",
				ariaLabel: "Menu d'options",
			},
			buttons: {
				cancel: "Annuler",
				save: "Enregistrer",
			},
		},
		productCard: {
			menu: {
				edit: "Modifier",
				remove: "Supprimer",
				ariaLabel: "Menu d'options",
			},
		},
		menuCard: {
			productsCount: "{{count}} produits",
		},
		empty: {
			title: "Aucune donnée trouvée",
			description: "Il n'y a pas de données à afficher.",
			button: "Ajouter un nouvel élément",
		},
		attachmentsFile: {
			loadingText: "Veuillez patienter pendant l'envoi du fichier...",
			dragText: "Glissez et déposez le fichier",
			clickText: "ou cliquez pour sélectionner",
			fileTypeText: "Type de fichier {{fileType}} jusqu'à {{fileSize}}.",
			maxSizeExceeded: "La taille du fichier dépasse la limite autorisée.",
		},
		modalSelectImage: {
			productImage: "Modifier l'image",
			setTagInput: "rechercher le produit à l'aide de mots-clés",
			confirm: "Confirmer",
			notInformed: "Nom non renseigné",
			selectFrom: "Sélectionnez une image de votre ",
			computer: "ordinateur",
			addImage: "Ajouter une image",
			typeOfFile: "Type de fichier .jpg, .jpeg, .png jusqu'à 5MB",
			errorCreatingImageUrl: "Erreur lors de la création de l'URL de l'image",
		},
		employeePdvLink: {
			manualDistribution: "Distribuer manuellement",
			description:
				"Choisissez pour quels points de vente tous les <strong>{{count}} {{roleName}}</strong> vont travailler",
			selectedCount: "{{count}} Sélectionnés",
		},
	},
};
